import axios from './_nestAxios'

export const self = {
  obtenerInfoIsla: () => axios.get('/usuarios/self/info-isla'),
  obtenerSeriesxTipoSerie: params => axios.get('/usuarios/self/series', { params }),
  obtenerInfoPersonal: () => axios.get('/usuarios/self/info-personal'),
  actualizarInfoPersonal: data => axios.put('/usuarios/self/actualizar-informacion-personal', data),
  actualizarContrasena: data => axios.put('/usuarios/self/actualizar-contrasena', data)
}

export const obtenerxIdAsEdicion = id => axios.get(`/usuarios/${id}`)
export const obtenerxIdAsInfoFirmas = id => axios.get(`/usuarios/${id}/firmas`)
export const obtenerTodoAsSelect = idOficina =>
  axios.get('/usuarios', { params: { tipoConsulta: 'select', idOficina } })
export const obtenerInfoSedesSeries = () => axios.get('/usuarios/info-sedes-series')

export const nuevo = data => axios.post(`/usuarios`, data)
export const nuevaFirmaxIdUsuario = (idUsuario, data) => axios.post(`/usuarios/${idUsuario}/firma`, data)

export const actualizarxId = (id, data) => axios.put(`/usuarios/${id}`, data)
export const cambiarContrasenia = (id, data) => axios.put(`/usuarios/${id}/actualizar-contrasena`, data)

export const obtenerFlagsActual = () => axios.get('/usuarios/self/flags')

export const eliminarxId = id => axios.delete(`/usuarios/${id}`)
export const eliminarFirmaxIdUsuarioxTipoFirma = (idUsuario, tipoFirma) =>
  axios.delete(`/usuarios/${idUsuario}/firmas/${tipoFirma}`)
